module.exports = __webpack_public_path__ + "static/img/preview-07.c924a055.webp";